/** Endpoints #28/#39 — post preview popup and its on-demand raw-item lookup. */

import type { PostDetailResponse, PostRawResponse } from '@lw/shared';
import { apiJson } from './client';

/** #28 `GET /api/posts/:id` */
export function getPost(postId: number, signal?: AbortSignal): Promise<PostDetailResponse> {
  return apiJson<PostDetailResponse>(`/posts/${postId}`, { signal });
}

/**
 * #39 `GET /api/posts/:id/raw` — the provider item behind a post. Fetched only when the user opens
 * the raw inspector: the server scans stored payloads for it, so it is not free (§7.5).
 */
export function getPostRaw(postId: number, signal?: AbortSignal): Promise<PostRawResponse> {
  return apiJson<PostRawResponse>(`/posts/${postId}/raw`, { signal });
}
